/* eslint-disable @typescript-eslint/no-explicit-any */
import { Navigate, Route, Routes } from 'react-router-dom'

import { constants, paths } from 'apps'
import { RaceDetail } from 'features/Race/pages'
import { useAppSelector, useLocalStorage } from 'hooks'
import { CommonLayout } from 'layouts'
import { useEffect } from 'react'
import { PrivateRoute } from 'routes'
import { handleAsyncRequest } from 'utils/helper'
import { getSignerByProvider } from 'utils/metamask'
import { CurrentEvent, OldFarm, RaceHistory, RaceHistoryDetail, SpecialRaceMain } from './pages'
import HorseDetail from './pages/Detail'
import { useAvailableWallet } from 'features/Auth/pages/Main/useAvailableWallet'
import { links } from 'apps'

function SpecialRace() {
  const [, setUserId] = useLocalStorage(constants.USER_ID_KEY, 0)
  const [, setAccessToken] = useLocalStorage(constants.ACCESS_TOKEN_KEY, null)
  const [, setRefreshToken] = useLocalStorage(constants.REFRESH_TOKEN_KEY, null)
  const auth = useAppSelector(state => state.auth)
  const providers = useAvailableWallet();
  const storedWalletName = localStorage.getItem("walletName");

  const matchedProviderDetail = providers.find(
    (p) => p.info.name === storedWalletName
  );
  const ethereumProvider = matchedProviderDetail?.provider ?? window.ethereum;

  const checkSignerProfile = async () => {
    const [signerError] = await handleAsyncRequest(getSignerByProvider(ethereumProvider))
    if (signerError) {
      setUserId(0)
      setAccessToken('')
      setRefreshToken('')
    }
  }
  useEffect(() => {
    if (providers?.length) {
      checkSignerProfile()
    }
  }, [providers])
  return (
    <Routes>
      <Route
        path={paths.default()}
        element={
          <PrivateRoute isLogged={auth.isLogged} layout={CommonLayout} navigate={links.home.index()}>
            <SpecialRaceMain />
          </PrivateRoute>
        }
      >
        <Route path={paths.specialRace.raceHistory()} element={<RaceHistory />} />
        <Route path={paths.specialRace.historyDetail()} element={<RaceHistoryDetail />} />
        <Route path={paths.specialRace.currentRace()} element={<CurrentEvent />} />
        <Route path={paths.specialRace.oldFarm()} element={<OldFarm />} />
      </Route>
      <Route
        path={paths.specialRace.historyHorseDetail()}
        element={
          <PrivateRoute isLogged={auth.isLogged} layout={CommonLayout} navigate={links.home.index()}>
            <HorseDetail />
          </PrivateRoute>
        }
      />
      <Route
        path={paths.specialRace.currentHorseDetail()}
        element={
          <PrivateRoute isLogged={auth.isLogged} layout={CommonLayout} navigate={links.home.index()}>
            <HorseDetail />
          </PrivateRoute>
        }
      />
      <Route
        path={paths.specialRace.raceDetail()}
        element={
          <PrivateRoute isLogged={auth.isLogged} layout={CommonLayout} navigate={links.home.index()}>
            <RaceDetail />
          </PrivateRoute>
        }
      />
      <Route path='*' element={<Navigate replace to={paths.notFound.feature()} />} />
    </Routes>
  )
}

export default SpecialRace
